import React, { useEffect, useState } from 'react';
import SenderItem from '../SenderItem';
import viewFolderStyles from './../viewfolders.module.scss';
import SearchSender from './SearchSender';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../redux';
import { setSelectedSenderName } from '../../../redux/sender/actions';

interface ISender {
    id: any;
    name: string;
    organisationId: string;
    count: number;
    isActive: boolean;
}

interface IViewSender extends ISender {
    sender: ISender;
}

export default function SenderView(props: any) {
    const dispatch = useDispatch();

    const [senders, setSenders] = useState<any[]>([]);

    const [searchBoxValue, setSearchBoxValue] = useState<any>('');

    const [sendersRecord, setSendersRecord] = useState<any[]>([]);

    const { selectedSender, senderOrganizationList, senderLogos } = useSelector(({ mailbox, sender }: IRootState) => ({
        documentList: mailbox.selectSenderFolder.folderRecords,
        selectedSender: mailbox.selectedSender,
        senderOrganizationList: sender.senderOrganizationList,
        senderLogos: sender.senderLogos,
    }));

    useEffect(() => {
        const mergedArray = senderOrganizationList.map((org) => {
            const image = senderLogos.find((item) => item.organisationId === org.id);

            return { ...org, imageUrl: image?.imageUrl };
        });

        setSenders(mergedArray);
        setSendersRecord(mergedArray);
    }, [senderOrganizationList, senderLogos]);

    useEffect(() => {
        searchBoxValue.trim().length != 0 && setSenderSearch(searchBoxValue);
    }, [sendersRecord]);

    const setActiveSenderClick: any = (sendersel: any, idx: any) => {
        dispatch(setSelectedSenderName(sendersel, true));
        props.onSenderChange();
    };

    const gatherFolders = (senders: Array<any>, senderElements: JSX.Element[]) => {
        senders.map((item, index) => {
            senderElements.push(
                <SenderItem
                    key={`sender_${index}`}
                    sender={item}
                    itemIndex={item.id}
                    onActiveSenderClick={setActiveSenderClick}
                    imageLogos={item.imageUrl}
                />
            );
        });
    };

    const renderFolders = (senders: Array<IViewSender>) => {
        const senderElements: JSX.Element[] = [];
        gatherFolders(senders, senderElements);
        return senderElements;
    };

    const setSenderSearch = (value: any) => {
        if (value.trim().length != 0) {
            const searchResults =
                sendersRecord != null &&
                sendersRecord.filter((item) => {
                    return item.name.toLowerCase().slice(0, value?.length) == value?.toLowerCase();
                });
            searchResults.length != 0 ? setSenders([...searchResults]) : setSenders([]);
        } else {
            setSenders([...sendersRecord]);
        }
    };

    useEffect(() => {
        if (selectedSender == null) {
            setSenders([
                ...senders.map((item) => (`${item.isActive}` == 'true' ? { ...item, isActive: false } : { ...item })),
            ]);
        }
    }, [selectedSender]);

    return (
        <div>
            <div className={`${!props.isSideBarShown ? 'd-none' : ''}`}>
                <SearchSender
                    onSenderNameChange={(val: any) => {
                        setSearchBoxValue(val);
                        setSenderSearch(val);
                    }}
                    isSender={senders?.length}
                />
            </div>
            <div className={`${viewFolderStyles.foldersList} d-flex flex-row align-items-center p-0 col-12`}>
                {senders.length != 0 && <div className="d-flex flex-column p-0 col-12">{renderFolders(senders)}</div>}
            </div>
        </div>
    );
}
